// Partage d'une fiche par lien — tout est encodé dans l'URL (aucun compte, aucun serveur)
// Aucune donnée personnelle (nom d'athlète) n'est placée dans l'URL partagée.
export const buildShareUrl = ({ exercise, oneRM, unit, rounding, pct }) => {
  const p = new URLSearchParams();
  if (exercise) p.set("ex", exercise);
  if (oneRM) p.set("rm", String(oneRM));
  if (unit) p.set("u", unit);
  p.set("r", String(rounding ?? 0));
  if (pct) p.set("p", String(pct));
  return `${window.location.origin}${window.location.pathname}?${p.toString()}`;
};

export const readShareParams = () => {
  const p = new URLSearchParams(window.location.search);
  if (!p.has("rm") && !p.has("ex")) return null;
  const num = (k) => {
    const v = Number(p.get(k));
    return Number.isFinite(v) ? v : null;
  };
  return {
    exercise: p.get("ex"),
    oneRM: num("rm"),
    unit: p.get("u") === "kg" ? "kg" : p.get("u") === "lbs" ? "lbs" : null,
    rounding: p.has("r") ? num("r") : null,
    pct: num("p"),
  };
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
};

// Mode intégration (iframe Wix) : ?embed=1
export const isEmbed = () =>
  new URLSearchParams(window.location.search).get("embed") === "1";

// URL de l'app complète (sans le mode intégration)
export const fullAppUrl = () => {
  const p = new URLSearchParams(window.location.search);
  p.delete("embed");
  const q = p.toString();
  return `${window.location.origin}${window.location.pathname}${q ? `?${q}` : ""}`;
};

// Envoie la hauteur du contenu au site hôte (évite le double défilement dans Wix)
// Origines autorisées à recevoir la hauteur du contenu (site hôte)
export const EMBED_ALLOWED_ORIGINS = [
  "https://krakenpp.ca",
  "https://www.krakenpp.ca",
  "https://editor.wix.com",
  "https://www.wix.com",
];

export const startHeightSync = () => {
  const post = () => {
    const h = Math.ceil(document.documentElement.scrollHeight);
    const msg = { type: "kraken-calc-height", height: h };
    EMBED_ALLOWED_ORIGINS.forEach((origin) => {
      try {
        window.parent?.postMessage(msg, origin);
      } catch (e) {
        /* origine non correspondante : message non délivré */
      }
    });
  };
  post();
  const ro = new ResizeObserver(post);
  ro.observe(document.body);
  window.addEventListener("load", post);
  return () => ro.disconnect();
};
